<template>
  <div class="w-full height-100">
    <el-dialog
      title=""
      :visible.sync="isShowCoupon"
      :direction="direction"
      :before-close="handleClose"
      width="40%"
    >
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          {{ AddEdit }} Coupon
        </h3></template
      >
      <el-form
        role="form"
        class=""
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <div>
          <div class="">
            <div class="relative">
              <small class="fsize12 bg-white text-dark font-medium"
                >Coupon Name</small
              >
              <el-form-item prop="name">
                <el-input
                  placeholder="Enter..."
                  v-model="ruleForm.name"
                  data-vv-validate-on="input|blur"
                  v-validate="'required'"
                  name="couponName"
                  class="rounded-xl mt-2"
                />
              </el-form-item>
              <!-- <span class="text-danger fsize10">
                {{ errors.first("name") }}
              </span> -->
            </div>

            <div class="relative mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >Add Description</small
              >
              <el-form-item prop="description">
                <el-input
                  type="textarea"
                  placeholder="Enter..."
                  v-model="ruleForm.description"
                  class="rounded-xl mt-2"
                />
              </el-form-item>
            </div>

            <div class="relative mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >Coupon Code</small
              >
              <el-form-item prop="code">
                <el-input
                  placeholder="Enter..."
                  v-model="ruleForm.code"
                  class="rounded-xl mt-2"
                  data-vv-validate-on="input|blur"
                  v-validate="'required'"
                  name="couponCode"
                />
              </el-form-item>
              <!-- <span class="text-danger fsize10">
                {{ errors.first("name") }}
              </span> -->
            </div>

            <div class="relative mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >Coupon Discount Percentage %</small
              >
              <el-form-item prop="discountPercentage">
                <el-input
                  placeholder="Enter..."
                  v-model="ruleForm.discountPercentage"
                  class="rounded-xl mt-2"
                  data-vv-validate-on="input|blur"
                  v-validate="'required|numeric'"
                  name="discount%"
                  :maxlength="2"
                />
              </el-form-item>
              <!-- <span class="text-danger fsize10">
                {{ errors.first("name") }}
              </span> -->
            </div>

            <div class="relative mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >Coupon Discount Limit</small
              >
              <el-form-item prop="discountLimit">
                <el-input
                  placeholder="Enter..."
                  v-model="ruleForm.discountLimit"
                  class="rounded-xl mt-2"
                  data-vv-validate-on="input|blur"
                  v-validate="'numeric'"
                  name="discountLimit"
                />
              </el-form-item>
              <!-- <span class="text-danger fsize10">
                {{ errors.first("name") }}
              </span> -->
              <!-- <el-checkbox v-model="checked" class="pl-0 fsize12"
              >Check/Un-check to toggle discount limit</el-checkbox
            > -->
            </div>

            <div class="relative mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >Minimum Amount Purchase</small
              >
              <el-form-item prop="minimumPurchase">
                <el-input
                  placeholder="Enter..."
                  v-model="ruleForm.minimumPurchase"
                  class="rounded-xl mt-2"
                  data-vv-validate-on="input|blur"
                  v-validate="'numeric'"
                  name="discountLimit"
                />
              </el-form-item>
              <!-- <span class="text-danger fsize10">
                {{ errors.first("name") }}
              </span> -->

              <!-- <el-checkbox v-model="checked" class="pl-0 fsize12"
              >Check/Un-check to toggle discount limit</el-checkbox
            > -->
            </div>

            <div class="relative mt-4">
              <small
                class="flex fsize12 bg-white text-dark font-medium justify-between"
                >User limit
                <span v-if="AddEdit === 'Edit'">
                  Usage: {{ usage }}</span
                ></small
              >
              <el-form-item prop="usageLimit">
                <el-input
                  placeholder="Enter..."
                  v-model="ruleForm.usageLimit"
                  class="rounded-xl mt-2"
                  data-vv-validate-on="input|blur"
                  v-validate="'numeric'"
                  name="discountLimit"
                />
              </el-form-item>
              <!-- <span class="text-danger fsize10">
                {{ errors.first("name") }}
              </span> -->
            </div>

            <div class="relative mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >Start Date</small
              >

              <div>
                <el-form-item prop="startDate">
                  <el-date-picker
                    v-model="ruleForm.startDate"
                    type="date"
                    placeholder="Pick a day"
                    class="mt-2 w-full"
                    data-vv-validate-on="input|blur"
                    v-validate="'required'"
                    name="startDate"
                    format="dd-MM-yyyy"
                    :picker-options="startPickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
              </div>
              <!-- <span class="text-danger fsize10">
                {{ errors.first("name") }}
              </span> -->
            </div>

            <div class="relative mt-4">
              <small class="fsize12 bg-white text-dark font-medium"
                >End Date</small
              >

              <div>
                <el-form-item prop="endDate">
                  <el-date-picker
                    v-model="ruleForm.endDate"
                    type="date"
                    placeholder="Pick a day"
                    class="mt-2 w-full"
                    data-vv-validate-on="input|blur"
                    v-validate="'required'"
                    format="dd-MM-yyyy"
                    name="endDate"
                    :picker-options="endPickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
                <!-- <span class="text-danger fsize10">
                  {{ errors.first("name") }}
                </span> -->
              </div>
            </div>
          </div>
          <div class="flex justify-end">
            <!-- :disabled="isInvalid" -->
            <vs-button
              variant="primary"
              class="mt-4 px-8 w-full py-4"
              @click="handleSubmit('ruleForm')"
              >Submit</vs-button
            >
          </div>
        </div>
      </el-form>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleClick('controlCenter')"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Coupon Management
          </h2>
        </div>
      </div>
    </div>

    <div class="fixed-top bg-white p-6">
      <div class="flex justify-end">
        <vs-button
          @click="handleAddEdit('Add')"
          variant="primary"
          class="border-0 font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
        >
          Add Coupon Code
        </vs-button>
      </div>
      <div class="">
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-colorpd"
        >
          <el-table-column
            :index="indexmethod"
            type="index"
            label="Sr.no"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="couponName"
            label="Coupon Name"
            min-width="140px"
          >
          </el-table-column>

          <el-table-column
            prop="couponCode"
            label="Coupon Code"
            min-width="120px"
          >
          </el-table-column>

          <el-table-column
            prop="discountPercentage"
            label="Discount %"
            min-width="80px"
          >
          </el-table-column>
          <el-table-column
            prop="discountLimit"
            label="Discount Limit"
            min-width="100px"
          >
          </el-table-column>

          <el-table-column
            prop="minimumAmountPurhcase"
            label="Minimum Purchase"
            min-width="120px"
          >
          </el-table-column>

          <el-table-column
            prop="usageLimit"
            label="User Limit"
            min-width="90px"
          >
            <template v-slot="{ row }">
              {{ `${row.usageLimit}/${row.usage}` }}
            </template>
          </el-table-column>

          <el-table-column prop="startDate" label="Start Date" min-width="90px">
            <template v-slot="{ row }">
              {{ new Date(row.startDate).toLocaleDateString("en-IN") }}
            </template>
          </el-table-column>

          <el-table-column
            prop="expiryDate"
            label="Expiry Date"
            min-width="90px"
          >
            <template v-slot="{ row }">
              {{ new Date(row.expiryDate).toLocaleDateString("en-IN") }}
            </template>
          </el-table-column>

          <el-table-column prop="actions" label="Actions" min-width="90px">
            <template v-slot="{ row }">
              <div class="flex gap-1 items-center">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="handleAddEdit('Edit', row)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="deletePopup(row._id)"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            layout="prev,pager,next"
            :total="totalRows"
            :page-size="perPage"
            @current-change="setPage"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isShowCoupon: false,
      direction: "rtl",

      // name: "",
      // description: "",
      // code: "",
      // discountPercentage: "",
      // discountLimit: "",
      // minimumPurchase: "",
      // usageLimit: "",
      // startDate: null,
      // endDate: null,
      usage: 0,

      AddEdit: "Add",
      couponId: "",

      totalRows: 0,
      perPage: 10,
      currentPage: 1,

      tableData: [
        // {
        //   couponName: "20 December 2019",
        //   couponCode: "Tom",
        //   discount: "PR-1",
        //   discountLimit: "Active",
        //   minimumPurchase: "No. 189, Grove St, Los Angeles",
        //   userLimit: "CA 90036",
        //   startDate: "10/02/2022",
        //   expiryDate: "10/04/2023",
        // },
        // {
        //   couponName: "20 December 2019",
        //   couponCode: "Tom",
        //   discount: "PR-1",
        //   discountLimit: "Active",
        //   minimumPurchase: "No. 189, Grove St, Los Angeles",
        //   userLimit: "CA 90036",
        //   startDate: "10/02/2022",
        //   expiryDate: "10/04/2023",
        // },
        // {
        //   couponName: "20 December 2019",
        //   couponCode: "Tom",
        //   discount: "PR-1",
        //   discountLimit: "Active",
        //   minimumPurchase: "No. 189, Grove St, Los Angeles",
        //   userLimit: "CA 90036",
        //   startDate: "10/02/2022",
        //   expiryDate: "10/04/2023",
        // },
        // {
        //   couponName: "20 December 2019",
        //   couponCode: "Tom",
        //   discount: "PR-1",
        //   discountLimit: "Active",
        //   minimumPurchase: "No. 189, Grove St, Los Angeles",
        //   userLimit: "CA 90036",
        //   startDate: "10/02/2022",
        //   expiryDate: "10/04/2023",
        // },
      ],

      startPickerOptions: {
        disabledDate: this.startDisableDate,
      },
      endPickerOptions: {
        disabledDate: this.endDisableDate,
      },

      ruleForm: {
        name: "",
        description: "",
        code: "",
        discountPercentage: "",
        discountLimit: "",
        minimumPurchase: "",
        usageLimit: "",
        startDate: null,
        endDate: null,
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please Enter Coupon Name",
            trigger: "blur",
          },
        ],
        description: [
          {
            message: "Please Enter Coupon Description",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "Please Enter Coupon Code",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z0-9]*$/,
            message: "Coupon Code should be alpha numeric only",
            trigger: "blur",
          },
        ],
        discountPercentage: [
          {
            required: true,
            message: "Please Enter Coupon Discount Percentage",
            trigger: "blur",
          },
          {
            pattern: /^\d{1,2}$/,
            message: "Discount Percentage should be numeric",
            trigger: "blur",
          },
        ],
        discountLimit: [
          {
            message: "Please Enter Coupon Discount Limit",
            trigger: "blur",
          },
          {
            pattern: /^[0-9]*$/,
            message: "Discount Limit should be numeric",
            trigger: "blur",
          },
        ],
        minimumPurchase: [
          {
            message: "Please Enter Coupon Minimum Purchase",
            trigger: "blur",
          },
          {
            pattern: /^[0-9]*$/,
            message: "Minimum Purchase should be numeric",
            trigger: "blur",
          },
        ],
        usageLimit: [
          {
            message: "Please Enter Coupon Usage Limit",
            trigger: "blur",
          },
          {
            pattern: /^[0-9]*$/,
            message: "Usage Limit should be numeric",
            trigger: "blur",
          },
        ],
        startDate: [
          {
            type: "date",
            required: true,
            message: "Please Select Start Date",
            trigger: "blur",
          },
        ],
        endDate: [
          {
            type: "date",
            required: true,
            message: "Please Select Expiry Date",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("admin", ["login"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
    ...mapState("EcomCoupon", {
      coupon: "coupon",
    }),
    isInvalid() {
      return this.errors.any();
    },
  },
  watch: {
    async currentPage() {
      await this.getCoupon();
    },
  },
  methods: {
    endDisableDate(date) {
      if (this.ruleForm.startDate) {
        let newDate = new Date(date);
        return newDate <= new Date(this.ruleForm.startDate);
      }
    },
    startDisableDate(date) {
      if (this.ruleForm.endDate) {
        let newDate = new Date(date);
        return newDate >= new Date(this.ruleForm.endDate);
      }
    },
    handleSubmit(formName) {
      this.ruleForm.name = this.ruleForm.name.trim();
      this.ruleForm.description = this.ruleForm.description.trim();
      this.ruleForm.code = this.ruleForm.code.trim();
      this.ruleForm.discountPercentage = this.ruleForm.discountPercentage
        .toString()
        .trim();
      this.ruleForm.discountLimit = this.ruleForm.discountLimit
        .toString()
        .trim();
      this.ruleForm.minimumPurchase = this.ruleForm.minimumPurchase
        .toString()
        .trim();
      this.ruleForm.usageLimit = this.ruleForm.usageLimit.toString().trim();

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.handleAddCoupon();
        } else {
          // this.formfield();
          return false;
        }
      });
    },
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
      this.ruleForm.name = "";
      this.ruleForm.description = "";
      this.ruleForm.code = "";
      this.ruleForm.discountPercentage = "";
      this.ruleForm.discountLimit = "";
      this.ruleForm.minimumPurchase = "";
      this.ruleForm.usageLimit = "";
      this.ruleForm.startDate = null;
      this.ruleForm.endDate = null;
      this.usage = 0;
      this.couponId = "";
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    handleAddEdit(name, data = {}) {
      if (name === "Add") {
        this.resetForm("ruleForm");
      } else if (name === "Edit") {
        this.couponId = data._id ? data._id : "";
        this.ruleForm.name = data.couponName ? data.couponName : "";
        this.ruleForm.description = data.description ? data.description : "";
        this.ruleForm.code = data.couponCode ? data.couponCode : "";
        this.ruleForm.discountPercentage = data.discountPercentage
          ? data.discountPercentage
          : "";
        this.ruleForm.discountLimit = data.discountLimit
          ? data.discountLimit
          : "";
        this.ruleForm.minimumPurchase = data.minimumAmountPurhcase
          ? data.minimumAmountPurhcase
          : "";
        this.ruleForm.usageLimit = data.usageLimit ? data.usageLimit : "";
        this.ruleForm.startDate = data.startDate
          ? new Date(data.startDate)
          : "";
        this.ruleForm.endDate = data.expiryDate
          ? new Date(data.expiryDate)
          : "";
        this.usage = data.usage ? data.usage : 0;
      }
      this.AddEdit = name;
      this.isShowCoupon = true;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async deletePopup(couponId) {
      this.$swal({
        title: "Are you sure?",
        type: "Warning",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#cd3197",
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$swal("Deleted", "Successfully deleted", "success");
          this.handleDelete(couponId);
        }
      });
    },
    async handleDelete(couponId) {
      let payload = {
        couponId: couponId,
        adminId: this.login._id,
      };
      let data = await this.$store.dispatch("EcomCoupon/deleteCoupon", payload);
      this.currentPage = 1;
      this.getCoupon();
    },
    async handleAddCoupon() {
      const payload = new FormData();
      payload.append("couponName", this.ruleForm.name);
      payload.append("description", this.ruleForm.description);
      payload.append("couponCode", this.ruleForm.code);
      payload.append("discountPercentage", this.ruleForm.discountPercentage);
      payload.append("discountLimit", this.ruleForm.discountLimit);
      payload.append("minimumAmountPurhcase", this.ruleForm.minimumPurchase);
      payload.append("usageLimit", this.ruleForm.usageLimit);
      payload.append("startDate", this.ruleForm.startDate);
      payload.append("expiryDate", this.ruleForm.endDate);
      payload.append("adminId", this.login._id);

      if (this.AddEdit === "Edit" && this.couponId) {
        payload.append("couponId", this.couponId);
      }

      let loader;
      try {
        // console.log(payload);
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let createCoupon;
        if (this.AddEdit === "Add") {
          createCoupon = await this.$store.dispatch(
            "EcomCoupon/addCoupon",
            payload
          );
        } else if (this.AddEdit === "Edit") {
          createCoupon = await this.$store.dispatch(
            "EcomCoupon/updateCoupon",
            payload
          );
        }

        if (createCoupon.code === 200) {
          // console.log(createCoupon);
          loader.close();
          this.handleClose();
          await this.$swal({
            title: `Coupon ${
              this.AddEdit === "Add" ? "Created" : "Updated"
            } Successfully!`,
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });

          this.resetForm("ruleForm");
          this.getCoupon();
          // console.log(this.testimonial);
        }
        loader.close();
      } catch (error) {
        loader.close();

        if (error.response.data.code !== 500) {
          this.$notify.error({
            message: `${
              error.response.data.message
                ? error.response.data.message
                : "Something went wrong"
            }`,
            position: "bottom-right",
          });
        }
      }
    },
    async getCoupon() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };
      let loader;

      // if (this.search !== "")
      //   Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const getCoupon = await this.$store.dispatch(
          "EcomCoupon/getCoupon",
          payload
        );
        // console.log(getCoupon);
        loader.close();
        if (getCoupon.code === 200) {
          this.totalRows = this.coupon.totalCount;
          this.tableData = this.coupon.result;
        }
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    handleClose() {
      this.isShowCoupon = false;
    },
    setPage(page) {
      this.currentPage = page;
    },
  },
  async mounted() {
    await this.getCoupon();
  },
};
</script>
